import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IsAAdmDirective } from './is-aadm.directive';
import { IsCustomerDirective } from './is-customer.directive';
import { IsCustomerAdmDirective } from './is-customer-adm.directive';
import { IsPortalManagerDirective } from './is-portal-manager.directive';
import { IsNotPortalManagerDirective } from './is-not-portal-manager.directive';
import { blockButtonDirective } from './block-button.directive';
import { DisableIfSellerDirective } from './disable-If-seller.directive';
import { ProductAvailabilityDirective } from './product-availability.directive';
import { HasFeatureDirective } from './has-feature.directive';
import { BadgeProDirective } from './badge-pro.directive';
import { DisableFeatureDirective } from './disable-feature.directive';
import { OpenLinkDirective } from './open-link.directive';
import { DisableIfVisitorDirective } from './disable-If-visitor.directive';
import { ClearIfHasFeatureDirective } from './clear-if-has-feature.directive';
import { DisableNewClientDirective } from './disable-new-client.directive';
import { ObserveElementDirective } from './observe-element.directive';
import { HasModuleDirective } from './has-module.directive';

@NgModule({
	declarations: [
		HasFeatureDirective,
		IsPortalManagerDirective,
		IsAAdmDirective,
		IsCustomerDirective,
		IsCustomerAdmDirective,
		IsNotPortalManagerDirective,
		blockButtonDirective,
		DisableIfSellerDirective,
		ProductAvailabilityDirective,
		BadgeProDirective,
		DisableFeatureDirective,
		OpenLinkDirective,
		DisableIfVisitorDirective,
		ClearIfHasFeatureDirective,
		DisableNewClientDirective,
		ObserveElementDirective,
		HasModuleDirective,
	],
	imports: [CommonModule],
	exports: [
		HasFeatureDirective,
		IsPortalManagerDirective,
		IsAAdmDirective,
		IsCustomerDirective,
		IsCustomerAdmDirective,
		IsNotPortalManagerDirective,
		blockButtonDirective,
		DisableIfSellerDirective,
		ProductAvailabilityDirective,
		BadgeProDirective,
		DisableFeatureDirective,
		OpenLinkDirective,
		DisableIfVisitorDirective,
		ClearIfHasFeatureDirective,
		DisableNewClientDirective,
		ObserveElementDirective,
		HasModuleDirective,
	],
})
export class DirectivesModule {}
